// LAS LÍNEAS POR LAS QUE SE PUEDE CERRAR UNA HORA, EN PANTALLA.
//
// Lissette 2026-10-11: primero Salud / Medicare / Vida, y el mismo día
// "no solamente para Medicare o para salud, para todo tipo de seguro".
// Las usan el calendario ("🔒 Bloquea la hora para"), Mi Booking Link
// ("¿Para qué líneas es este enlace?") y la página pública de agendar
// ("¿Para qué es tu cita?").
//
// Las claves tienen que ser EXACTAMENTE las de LINEAS en
// deskte-api/src/utils/bloqueoPorLinea.ts: una clave que el servidor no conoce
// se descarta al guardar, sin error. Lo comprueba bloqueoPorLinea.test.ts.
export const LINEAS_DE_BLOQUEO = [
  { id: "salud", es: "Salud", en: "Health" },
  { id: "medicare", es: "Medicare", en: "Medicare" },
  { id: "vida", es: "Vida", en: "Life" },
  { id: "dental", es: "Dental y visión", en: "Dental & vision" },
  { id: "suplementarios", es: "Suplementarios", en: "Supplemental" },
  { id: "auto", es: "Auto", en: "Auto" },
  { id: "casa", es: "Casa", en: "Home" },
  { id: "comercial", es: "Comercial", en: "Commercial" },
  { id: "otros", es: "Otros", en: "Other" },
];

/** El nombre de una línea en el idioma pedido; si no se conoce, la clave. */
export function nombreDeLinea(id, es = true) {
  const l = LINEAS_DE_BLOQUEO.find((x) => x.id === id);
  return l ? (es ? l.es : l.en) : id;
}

// Cada ramo del catálogo (policyTypes.js), en su línea. Es el espejo de
// LINEA_DEL_RAMO en el servidor, que es quien decide de verdad al guardar una
// Cita; aquí solo sirve para ENSEÑAR en el formulario qué va a bloquear.
const LINEA_DEL_RAMO = {
  aca: "salud", shortterm: "salud",
  ma: "medicare", medsup: "medicare", partd: "medicare",
  life: "vida", final: "vida",
  dental: "dental", vision: "dental",
  accident: "suplementarios", hosp: "suplementarios", suppl: "suplementarios",
  auto: "auto",
  home: "casa", renters: "casa", umbrella: "casa",
  commercial: "comercial", liability: "comercial",
  pet: "otros", travel: "otros", referred: "otros",
};

/** La línea de un ramo, o null si es un ramo propio de la agencia (= todas). */
export function lineaDelRamo(ramo) {
  return LINEA_DEL_RAMO[String(ramo || "").trim().toLowerCase()] || null;
}
